export const SET_LOCALIZATION = 'localization/SET_LOCALE'
